import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "inline-flex items-center mr-3"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "inline-flex rounded-full p-2.5"
}
const _hoisted_6 = { class: "w-6.5 pr-4 py-2" }
const _hoisted_7 = { class: "flex justify-center" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  colspan: "2",
  class: "p-0"
}
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "w-6.5 pr-4 py-2" }
const _hoisted_13 = { class: "flex justify-center" }
const _hoisted_14 = {
  key: 1,
  class: "py-8 text-center text-sm text-dark-gray-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExpandIcon = _resolveComponent("ExpandIcon")!
  const _component_CustomCheckbox = _resolveComponent("CustomCheckbox")!
  const _component_ExpandCollapseTransition = _resolveComponent("ExpandCollapseTransition")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['border-2 h-full overflow-y-auto border-opacity-10 rounded-lg py-2', _ctx.maxHeightClass])
  }, [
    (_ctx.nodes.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, null, -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: node.key
              }, [
                _createElementVNode("tr", {
                  class: _normalizeClass(["hover:bg-gray-100", _ctx.rowCursor(node)]),
                  onClick: ($event: any) => (_ctx.onNodeClicked(node))
                }, [
                  _createElementVNode("td", {
                    class: _normalizeClass(["pl-4 py-2 font-medium", { 'text-gray-400': _ctx.isDisabled(node) }])
                  }, [
                    (_ctx.hasExpandColumn)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                          (_ctx.childrenOf(node).length)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "inline-flex rounded-full p-2.5 hover:bg-gray-200 transition-colors",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleExpanded(node)), ["stop"])
                              }, [
                                _createVNode(_component_ExpandIcon, {
                                  color: "black",
                                  expand: _ctx.isExpanded(node),
                                  class: "w-3.5 h-3.5"
                                }, null, 8, ["expand"])
                              ], 8, _hoisted_4))
                            : (_openBlock(), _createElementBlock("span", _hoisted_5, _cache[0] || (_cache[0] = [
                                _createElementVNode("span", { class: "inline-block w-3.5 h-3.5" }, null, -1)
                              ])))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, _toDisplayString(node.label), 1)
                  ], 2),
                  _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_CustomCheckbox, {
                        tabbable: "",
                        checked: _ctx.isChecked(node),
                        indeterminate: _ctx.isIndeterminate(node),
                        disabled: _ctx.isDisabled(node),
                        "onUpdate:checked": ($event: any) => (_ctx.onNodeClicked(node))
                      }, null, 8, ["checked", "indeterminate", "disabled", "onUpdate:checked"])
                    ])
                  ])
                ], 10, _hoisted_2),
                (_ctx.childrenOf(node).length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                      _createElementVNode("td", _hoisted_9, [
                        _createVNode(_component_ExpandCollapseTransition, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", null, [
                              _createElementVNode("table", _hoisted_10, [
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childrenOf(node), (child) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: child.key,
                                      class: _normalizeClass(["hover:bg-gray-50", _ctx.rowCursor(child)]),
                                      onClick: ($event: any) => (_ctx.onNodeClicked(child))
                                    }, [
                                      _createElementVNode("td", {
                                        class: _normalizeClass(["pl-16 py-2 text-sm text-gray-700", { 'text-gray-400': _ctx.isDisabled(child) }])
                                      }, _toDisplayString(child.label), 3),
                                      _createElementVNode("td", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                          _createVNode(_component_CustomCheckbox, {
                                            tabbable: "",
                                            checked: _ctx.isChecked(child),
                                            disabled: _ctx.isDisabled(child),
                                            "onUpdate:checked": ($event: any) => (_ctx.onNodeClicked(child))
                                          }, null, 8, ["checked", "disabled", "onUpdate:checked"])
                                        ])
                                      ])
                                    ], 10, _hoisted_11))
                                  }), 128))
                                ])
                              ])
                            ], 512), [
                              [_vShow, _ctx.isExpanded(node)]
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]))
      : (_ctx.emptyLabel)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.emptyLabel), 1))
        : _createCommentVNode("", true)
  ], 2))
}